import React from 'react'
import { ButtonBase, makeStyles } from '@material-ui/core'
import {
  BASE_COLORS,
  ERROR_COLORS,
  GRAY_COLORS,
  INFO_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import CarImg from 'assets/img/car_placeholder.jpg'
import clsx from 'clsx'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 10,
    maxHeight: 105,
    gap: 12,
    backgroundColor: BASE_COLORS.White
  },
  carPhoto: {
    width: 136,
    height: 96,
    borderRadius: '10px 0px 0px 10px',
    position: 'relative',
    objectFit: 'cover'
  },
  price: {
    padding: '1px 6px',
    borderRadius: '0px 5px 0px 10px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    backgroundColor: WARNING_COLORS[300],
    color: GRAY_COLORS[800],
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '18px'
  },
  chipAster: {
    position: 'absolute',
    top: 5,
    right: 5
  },
  bonusAster: {
    position: 'absolute',
    top: 30,
    right: 5
  },
  chipStatus: {
    position: 'absolute',
    top: 5,
    left: 5
  },
  carInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 5,
    width: '100%'
  },
  title: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '18px'
  },
  characteristics: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    textAlign: 'left',
    maxWidth: 190
  },
  branch: {
    color: GRAY_COLORS[500],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px'
  },
  selected: {
    border: '2px solid ' + PRIMARY_COLORS['700'],
    backgroundColor: PRIMARY_COLORS['100']
  },
  isNotDemonstrated: {
    border: '2px solid ' + WARNING_COLORS['700'],
    backgroundColor: WARNING_COLORS['100']
  }
}))

const CarSelectionCard = ({ car, onClick, isChoosen, isNotDemonstrated }) => {
  const classes = useStyle()

  const handleEngineCapacity = volume => {
    return Math.ceil(+volume / 10) / 100
  }

  return (
    <ButtonBase
      className={clsx(
        classes.root,
        isChoosen && classes.selected,
        isNotDemonstrated && classes.isNotDemonstrated
      )}
      onClick={onClick}
    >
      <div className={classes.carPhoto}>
        <img
          className={classes.carPhoto}
          src={car?.photos?.[0] || CarImg}
          alt={'car'}
        />

        <div className={classes.chipStatus}>
          {car.hasOwnProperty('carStatus') && (
            <ChipStandard
              {...(car?.carStatus?.code === 'available'
                ? {
                    color: SUCCESS_COLORS[700],
                    backgroundColor: SUCCESS_COLORS[50]
                  }
                : car?.carStatus?.code === 'reserved'
                ? {
                    color: ERROR_COLORS[700],
                    backgroundColor: ERROR_COLORS[50]
                  }
                : {
                    color: GRAY_COLORS[700],
                    backgroundColor: GRAY_COLORS[50]
                  })}
            >
              {car?.carStatus?.name}
            </ChipStandard>
          )}
        </div>

        <div className={classes.chipAster}>
          {(car.hasOwnProperty('carbazar') ||
            car.hasOwnProperty('autoDiscount')) && (
            <ChipStandard
              {...(car.carbazar
                ? {
                    color: ERROR_COLORS[700],
                    backgroundColor: ERROR_COLORS[50]
                  }
                : car.autoDiscount
                ? {
                    color: INFO_COLORS[700],
                    backgroundColor: INFO_COLORS[50]
                  }
                : {
                    color: GRAY_COLORS[700],
                    backgroundColor: GRAY_COLORS[50]
                  })}
            >
              {car?.carbazar ? 'KB' : 'A'}
            </ChipStandard>
          )}
        </div>

        <div className={classes.bonusAster}>
          {!!car?.cashback && (
            <ChipStandard
              color={ERROR_COLORS[700]}
              backgroundColor={ERROR_COLORS[50]}
            >
              Б
            </ChipStandard>
          )}
        </div>

        <div className={classes.price}>
          {car?.price?.toString()?.thousandSeparator()} ₸
        </div>
      </div>

      <div className={classes.carInfo}>
        <div className={classes.title}>
          {`${typeof car?.marka === 'string' ? car?.marka : car?.marka?.name} ${
            typeof car?.model === 'string' ? car?.model : car?.model?.name
          } ${car?.year}`}{' '}
        </div>

        <div className={classes.characteristics}>{`${
          car.mileage ? car.mileage : '0'
        } км, ${
          car.engineCapacity ? handleEngineCapacity(car.engineCapacity) : '0'
        } (${
          typeof car.engineType === 'string'
            ? car.engineType
            : car.engineType?.name
            ? car.engineType?.name
            : ''
        }), ${
          typeof car.dwheelType === 'string'
            ? car.dwheelType
            : car.dwheelType
            ? car.dwheelType?.name?.toLowerCase()
            : ''
        }, ${car.transmission === 1 ? 'Автомат' : 'Механика'}`}</div>

        <div className={classes.branch}>
          {typeof car?.branch === 'string' ? car?.branch : car?.branch?.name}
        </div>
      </div>
    </ButtonBase>
  )
}

export default CarSelectionCard

export const TireSelectionCard = ({
  tire,
  onClick,
  isChoosen,
  isNotDemonstrated
}) => {
  const classes = useStyle()
  return (
    <ButtonBase
      className={clsx(
        classes.root,
        isChoosen && classes.selected,
        isNotDemonstrated && classes.isNotDemonstrated
      )}
      onClick={onClick}
    >
      <div className={classes.carPhoto}>
        <img
          className={classes.carPhoto}
          src={tire?.photos?.[0] || CarImg}
          alt={'tire'}
        />

        <div className={classes.price}>
          {tire?.price?.toString()?.thousandSeparator()} ₸
        </div>
      </div>

      <div className={classes.carInfo}>
        <div className={classes.title}>
          {`${typeof tire?.mark === 'string' ? tire?.mark : tire?.mark?.name} ${
            typeof tire?.model === 'string' ? tire?.model : tire?.model?.name
          }`}
        </div>

        <div className={classes.characteristics}>{`${tire.season || '-'}${
          tire.isStudded ? ', шипы' : ''
        }, R${tire.radius || '-'}, ${tire.width || '-'}мм, ${
          tire.height || '-'
        }мм, ${tire.averageWear !== undefined ? tire.averageWear : '-'}% ${
          tire.year || '-'
        } год`}</div>

        <div className={classes.branch}>
          {typeof tire?.branch === 'string' ? tire?.branch : tire?.branch?.name}
        </div>
      </div>
    </ButtonBase>
  )
}
